export function formatDateTimeAndUseOnlyParts(
    formatter: Intl.DateTimeFormat,
    value: Date | number,
    useOnlyPartsFn: (
        value: Intl.DateTimeFormatPart,
        index: number,
        array: Intl.DateTimeFormatPart[],
    ) => boolean,
) {
    return formatter
        .formatToParts(value)
        .filter(useOnlyPartsFn)
        .reduce(
            (formattedString, part) => formattedString.concat(part.value),
            "",
        )
        .trim();
}
